import { useState } from "react";
import { toast } from "sonner";
import { Section } from "./Section";
import AIButton from "./AIButton";
import { polishText } from "@/lib/api";

export default function SummarySection({ resume, setResume, open, onToggle }) {
  const [polishing, setPolishing] = useState(false);

  const polishSummary = async () => {
    if (!resume.summary?.trim()) {
      toast.error("Write a summary first");
      return;
    }
    setPolishing(true);
    try {
      const out = await polishText({
        text: resume.summary,
        kind: "summary",
        role: resume.personal.title,
      });
      setResume((r) => ({ ...r, summary: out }));
      toast.success("Summary polished");
    } catch (e) {
      toast.error("AI polish failed");
    } finally {
      setPolishing(false);
    }
  };

  return (
    <Section id="summary" title="Professional summary" open={open} onToggle={onToggle}>
      <div className="flex items-center justify-between mb-2">
        <div className="label-mono">2–3 sentences</div>
        <AIButton onClick={polishSummary} loading={polishing} testid="polish-summary-button" />
      </div>
      <textarea
        className="field-textarea min-h-[120px]"
        value={resume.summary}
        onChange={(e) => setResume((r) => ({ ...r, summary: e.target.value }))}
        placeholder="Product designer with 6+ years building consumer software..."
        data-testid="input-summary"
      />
    </Section>
  );
}
